export default __webpack_public_path__ + "static/media/koro-sports.1b16baee.svg";